import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function useTravelSearchShortcut(enabled = true) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) return;

    const shortcut = (event) => {
      if (
        event.key !== "/" ||
        event.defaultPrevented ||
        event.ctrlKey ||
        event.metaKey ||
        event.altKey ||
        event.repeat
      )
        return;
      if (
        event.target.closest?.(
          "input, textarea, select, [contenteditable=true], [role=combobox]",
        )
      )
        return;
      event.preventDefault();
      navigate("/search");
    };

    window.addEventListener("keydown", shortcut);
    return () => window.removeEventListener("keydown", shortcut);
  }, [enabled, navigate]);
}
